import { cDatabaseApi, cDbQuery } from "./DatabaseApi";
import { cPermission } from "./Permission";

export class cPermissionApi {
  public static async initPermissionApi() {
    cDatabaseApi.initDatabaseApi("Permissions");
  }

  public static async getPermissions() {
    const q = new cDbQuery("Permissions");
    const dbRows = await cDatabaseApi.query(q);
    return dbRows;
  }

  public static async addPermission(permission: cPermission): Promise<boolean> {
    const q = new cDbQuery("Permissions");
    q.setData(permission);
    const status = await cDatabaseApi.add(q);
    return status;
  }

  public static async updateUser(permission: cPermission): Promise<boolean> {
    const q = new cDbQuery("Permissions");
    q.setWhere("Name", permission.name);
    q.setData(permission);
    const status = await cDatabaseApi.update(q);

    return status;
  }

  public static async deletePermission(
    permission: cPermission
  ): Promise<boolean> {
    const q = new cDbQuery("Permissions");
    q.setWhere("Name", permission.name);
    const status = await cDatabaseApi.delete(q);

    return status;
  }
}
